// extracted by mini-css-extract-plugin
module.exports = {"main_div":"Recommendation_main_div__3KFDk","content_div":"Recommendation_content_div__1LW14","title_div":"Recommendation_title_div__3tmRg"};